import {Component} from 'react';
import PropTypes from 'prop-types';
import AnalyticsGateway from '../lib/AnalyticsGateway';
import {withRouter} from 'react-router-dom';
import * as Routes from '../Routes';
import {Link} from '@mui/material';

export class ExpandCollapseToggleButton extends Component {

  static propTypes = {
    disabled: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
    collapsed: PropTypes.bool,
    onChange: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      expanded: !props.collapsed
    };
  }

  onChange = () => {
    const {location: {pathname}, onChange} = this.props;

    const expanded = !this.state.expanded;
    onChange(expanded);
    this.setState({expanded});

    const {pageContext} = Routes.locationInfo(pathname);
    AnalyticsGateway.sendEvent({
      eventName: 'Change Search Results View',
      properties: [
        {label: 'Page', value: pageContext},
        {label: 'Object Context', value: expanded ? 'Expand All' : 'Collapse All'}
      ]
    });
  };

  render() {
    const {expanded} = this.state;

    return (
      <Link className={`expand-collapse-all${ this.props.disabled || ''}`}
            component="button"
            onClick={this.onChange}>
        {expanded ? 'Collapse All' : 'Expand All'}
      </Link>
    );
  }
}

export default withRouter(ExpandCollapseToggleButton);

